import React from 'react';

function LocationIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15 8.93555C15 13.8915 10.224 18.1655 8.562 19.5025C8.40348 19.6324 8.2049 19.7033 8 19.7033C7.7951 19.7033 7.59652 19.6324 7.438 19.5025C5.776 18.1655 1 13.8915 1 8.93555C1 7.07903 1.7375 5.29855 3.05025 3.9858C4.36301 2.67304 6.14348 1.93555 8 1.93555C9.85652 1.93555 11.637 2.67304 12.9497 3.9858C14.2625 5.29855 15 7.07903 15 8.93555Z" fill="currentColor" />
    </svg>
  );
}

export default LocationIcon;
